import React from 'react';
import { ArrowRight } from 'lucide-react';
const CARDS = [{
  title: 'Home mailbox',
  subtitle: 'Curbside, wall mount, locking, posts, numbers, and complete systems.',
  cta: 'Shop residential',
  href: '/6m8/mailboxes.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fgaines%2F2024+images%2FWM3.jpg&h=200&site=6153&user=4145&v=1&w=200'
}, {
  title: 'Community or commercial delivery',
  subtitle: 'CBUs, 4C systems, parcel lockers, private delivery, and commercial replacement parts.',
  cta: 'Shop commercial',
  href: '/6m8/commercial-mailboxes-lockers.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fauthflorence%2FVario+Depots%2F4C16D-20-DDB.jpg&h=200&site=6153&user=4145&v=1&w=200'
}, {
  title: 'Replacement part',
  subtitle: 'Locks, keys, doors, hinges, posts, numbers, and matching hardware.',
  cta: 'Find parts',
  href: '/6m8/mailboxes/mailbox-replacement-parts.html',
  illustration: <svg viewBox="0 0 100 100" className="w-16 h-16 text-brand-green" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-154">
        <path d="M30 70l25-25" data-id="element-155" />
        <circle cx="65" cy="35" r="15" data-id="element-156" />
        <path d="M60 40l10-10" data-id="element-157" />
        <path d="M25 75l-5 5 10 10 5-5" data-id="element-158" />
        <circle cx="45" cy="55" r="3" fill="currentColor" data-id="element-159" />
      </svg>
}, {
  title: 'Curb appeal & property details',
  subtitle: 'Address plaques, house numbers, decorative signs, street signs, and lighting.',
  cta: 'Shop signs & accents',
  href: '/6m8/address-plaques-and-house-numbers.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Fwhitehall%2Fwhitehall%2F10_Mailboxes%2F16103_KO.jpg&h=200&site=6153&user=4145&v=1&w=200'
}];
export function DecisionCards() {
  return <section id="shop-by-need" className="py-12 lg:py-16 bg-brand-cream relative z-20 -mt-4 lg:-mt-8" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4" data-id="element-161">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-162">
          <span className="text-brand-green font-bold tracking-wider uppercase text-xs mb-2 block flex items-center justify-center gap-2" data-id="element-163">
            <span className="w-8 h-px bg-brand-gold" data-id="element-164"></span>
            Shop by need
            <span className="w-8 h-px bg-brand-gold" data-id="element-165"></span>
          </span>
          <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-166">
            Start with the mailbox project you have in mind
          </h2>
          <p className="text-lg text-gray-600" data-id="element-167">
            Skip the catalog overload. Choose the path that matches how you're
            buying.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-168">
          {CARDS.map(card => <a key={card.title} href={card.href} className="group flex flex-col bg-white rounded-xl border border-brand-border shadow-sm hover:shadow-md hover:border-brand-green/50 hover:-translate-y-1 transition-all duration-300 overflow-hidden focus:outline-none focus:ring-2 focus:ring-brand-green focus:ring-offset-2 focus:ring-offset-brand-cream" data-id="element-169">
              {/* Image/Illustration Area */}
              <div className="bg-white h-40 flex items-center justify-center border-b border-brand-border/50 p-4" data-id="element-170">
                <div className="transform group-hover:scale-105 transition-transform duration-500 ease-out h-full w-full flex items-center justify-center" data-id="element-171">
                  {card.image ? <img src={card.image} alt={card.title} className="h-full w-auto object-contain mix-blend-multiply" data-id="element-172" /> : card.illustration}
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-173">
                <h3 className="text-xl font-serif font-bold text-brand-charcoal mb-2 group-hover:text-brand-green transition-colors" data-id="element-174">
                  {card.title}
                </h3>

                <p className="text-gray-600 text-sm mb-6 flex-grow leading-relaxed" data-id="element-175">
                  {card.subtitle}
                </p>

                <div className="flex items-center text-brand-green font-semibold text-sm group-hover:text-brand-red transition-colors mt-auto pt-4 border-t border-brand-border/30" data-id="element-176">
                  {card.cta}
                  <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-177" />
                </div>
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}